import { UPDATE_SEARCH_FORM } from '@location/actionTypes';

const updateSearchForm = payload => ({
  payload,
  type: UPDATE_SEARCH_FORM,
});

export default updateSearchForm;
